import { Tabs as AntdTabs, TabsProps } from "antd";
import { FC } from "react";
import { useQueryParam } from "use-query-params";

import { TAB_QUERY_NAME } from "./const";

const Tabs: FC<TabsProps> = (props) => {
  const [activeTab, setActiveTab] = useQueryParam<string | undefined>(
    TAB_QUERY_NAME
  );

  return (
    <AntdTabs
      onChange={(data) => setActiveTab(data)}
      defaultActiveKey={activeTab}
      {...props}
    />
  );
};

export default Tabs;
